import { TIconName } from '../../../ui/Icon/Icon.types';
import { ThemeEnum } from '../../../utils/enums';

export const iconSrcMap: Record<string, { [T in ThemeEnum]: TIconName }> = {
  user: {
    [ThemeEnum.Basic]: 'user',
    [ThemeEnum.Light]: 'userLight',
    [ThemeEnum.Dark]: 'userDark',
  },
  phoneCall: {
    [ThemeEnum.Basic]: 'phoneCall',
    [ThemeEnum.Light]: 'phoneCallLight',
    [ThemeEnum.Dark]: 'phoneCallDark',
  },
  envelopeSimple: {
    [ThemeEnum.Basic]: 'envelopeSimple',
    [ThemeEnum.Light]: 'envelopeSimpleLight',
    [ThemeEnum.Dark]: 'envelopeSimpleDark',
  },
};
